import { Modal } from "@mui/material";

import { makeStyles } from "@mui/styles";
import { PurchasingPower } from "./PurchasingPower";
import { Credit } from "./credit";
import { InvitedModal } from "./invited";
import { NetWorthModal } from "./netWorth";
import { PortfolioValueModal } from "./portfoliovalue";

let useStyles = makeStyles(() => ({
  modal_alert: {
    // minWidth: "15%",
    display: "flex",
    minHeight: 250,
    minWidth: 250,
    maxHeight: 600,
    overflow: "auto",
    backgroundColor: "#ffffff",
    zIndex: 100,

    borderRadius: 5,
    maxWidth: "90%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    outline: 0,
    border: 0,
    boxShadow: 24,
  },

  title: {},
}));

const Modals = ({
  modalState,
  handleCloseModal,
  sumTotalAssets,
  sumTotalObligations,
  net_Worth,
}) => {
  let classes = useStyles();

  return (
    <div>
      {" "}
      <Modal
        open={modalState.isOpen}
        onClose={handleCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes["modal_alert"]}>
          <div className="w-full  h-full p-4">
            <div>
              <p>{modalState?.type}</p>
              {modalState?.type === "اعتبار" && <Credit />}
              {modalState?.type === "دعوت شده" && <InvitedModal />}
              {modalState?.type === "خالص دارایی" && (
                <NetWorthModal
                  sumTotalAssets={sumTotalAssets}
                  sumTotalObligations={sumTotalObligations}
                  net_Worth={net_Worth}
                />
              )}
              {modalState?.type === "ارزش پرتفوی" && <PortfolioValueModal />}
              {modalState?.type === "قدرت خرید" && <PurchasingPower />}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Modals;
